module.exports = __webpack_public_path__ + "media/components/Authorization/Login/profile-1a494610dc165c89518fd3ec1f29697d.svg";